import { createTheme } from '@mui/material';

export const mainTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
        main: '#616161',
        },
        secondary: {
        main: '#ff5252',
        }
    }
});